module.exports = __webpack_public_path__ + "assets/futurafuturisc-webfont.737cdfe86171974e354a5ca5ccf759ab365f7b4edd66ba9aea824105a72fa672.woff2";